<template>
  <span class="of-hidden d-flex align-center">
    <!-- FIXME v-img cannot be empty or it flickers/re-renders component weirdly -->
    <!-- probably move away from v-img entirely for anything inside virtual scroller views cuz of inters. obser. -->
    <!-- Can just style the v-responsive div with background-url and size cover -->
    <v-img
      v-if="!noIcon"
      :src="favicon" :aspect-ratio="1" width="1em" contain
      class="flex-grow-0 text-body-1 mr-2 rounded"
      :class="bookmark.hasFavicon ? '' : bookmark.colorClasses"
    >
      <!-- Empty content to avoid flickering -->
      <template #placeholder />
    </v-img>
    <span class="d-block text-truncate">{{ domain }}</span>
  </span>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  noIcon: Boolean,
  bookmark: {
    type: Object,
    default: null,
  },
})

const domain = computed(() => {
  // The backend now provides the correct domain with compound TLDs handled
  // No need for additional processing
  return props.bookmark.domain
})

const favicon = computed(() => {
  return props.bookmark.faviconUrl
})
</script>
